import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { Calendar } from '../../../../ui/molecules/calendar'
import { ProtocolSearch } from '../../../../ui/molecules/ProtocolSearch'
import { MultiProtocolSearch } from '../../../../ui/molecules/ProtocolSearch/multisearch'
import { MadfarmStaticSelect } from '../../../../ui/molecules/select/newSelect/static'
import TextArea from '../../../../ui/molecules/textArea'
import { ReinforcedControlMeasureMotivationOptions } from '../../../../utils'
import { ReinforcedMotivationsEnum } from '../dataService/dto'
import { setReinforcedCreationActiveFrom, setReinforcedCreationClosingDate, setReinforcedCreationClosingMotivationNote, setReinforcedCreationClosingNote, setReinforcedCreationClosingProtocolId, setReinforcedCreationDepartureProtocolIds, setReinforcedCreationEntryProtocolIds, setReinforcedCreationMotivationNote, setReinforcedCreationMotivationType, setReinforcedCreationNote } from '../slice'
import '../styles.scss'

export function ReinforcedControlMeasureForm() {
    const dispatch = useAppDispatch()
    const reinforcedControlMeasureState = useAppSelector(state => state.reinforcedControlMeasure)

    return (
        <div className="flex flex-col gap-6 p-6">
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Applicazione della Misura di Controllo Rinforzato</span>
                </div>
                <div className="p-6 flex flex-col gap-4">
                    <div className="grid grid-cols-2 gap-6">
                        <Calendar
                            label="Misura di Controllo Rinforzato attiva dal: "
                            errorLabel={reinforcedControlMeasureState.reinforcedControlMeasureErrors.activeFrom ? 'Data mancante' : undefined}
                            selected={reinforcedControlMeasureState.reinforcedControlMeasuresCreationRequest.activeFrom}
                            onChange={(date) => dispatch(setReinforcedCreationActiveFrom(date))}
                        />
                        <MadfarmStaticSelect
                            noOptionsMessage=''
                            label="Motivazione"
                            error={reinforcedControlMeasureState.reinforcedControlMeasureErrors.motivationType}
                            errorLabel='Motivazione mancante'
                            placeholder={'Seleziona motivazione...'}
                            value={reinforcedControlMeasureState.reinforcedControlMeasuresCreationRequest.motivationType}
                            options={ReinforcedControlMeasureMotivationOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setReinforcedCreationMotivationType(newValue))
                            }}
                        />
                    </div>
                    {
                        reinforcedControlMeasureState.reinforcedControlMeasuresCreationRequest.motivationType === ReinforcedMotivationsEnum.ALTRO && (
                            <div className='grid grid-cols'>
                                <TextArea
                                    label="Descrizione della motivazione"
                                    onChangeText={(text) => dispatch(setReinforcedCreationMotivationNote(text))}
                                />
                            </div>
                        )
                    }
                    <div className='border-[0.5px] border-neutral-200' />
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">
                        Elenco Documenti che hanno generato l'applicazione della misura (Entrata)
                    </span>
                    <div className='grid grid-cols gap-6'>
                        <MultiProtocolSearch
                            type='entry'
                            onSelect={(value) => dispatch(setReinforcedCreationEntryProtocolIds(value))}
                        />
                    </div>
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">
                        Elenco Documenti che hanno generato l'applicazione della misura (Partenza)
                    </span>
                    <div className='grid grid-cols gap-6'>
                        <MultiProtocolSearch
                            type='departure'
                            onSelect={(value) => dispatch(setReinforcedCreationDepartureProtocolIds(value))}
                        />
                    </div>
                    <div className='border-[0.5px] border-neutral-200' />
                    <TextArea
                        label="Note"
                        onChangeText={(text) => dispatch(setReinforcedCreationNote(text))}
                    />
                </div>
            </div>
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Chiusura della Misura di Controllo Rinforzato</span>
                </div>
                <div className="p-6 flex flex-col gap-4">
                    <Calendar
                        label='Misura di Controllo Rinforzato chiusa il: '
                        selected={reinforcedControlMeasureState.reinforcedControlMeasuresCreationRequest.closingDate}
                        onChange={(date) => dispatch(setReinforcedCreationClosingDate(date))}
                        onClear={(date) => dispatch(setReinforcedCreationClosingDate(date))}
                    />
                    <TextArea
                        label="Descrizione della motivazione di chiusura: "
                        onChangeText={(text) => dispatch(setReinforcedCreationClosingMotivationNote(text))}
                    />
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">
                        Comunicazione chiusura al Cliente
                    </span>
                    <ProtocolSearch
                        type='departure'
                        onSelect={(value) => dispatch(setReinforcedCreationClosingProtocolId(value))}
                    />
                    <TextArea
                        label="Note"
                        onChangeText={(text) => dispatch(setReinforcedCreationClosingNote(text))}
                    />
                </div>
            </div>
        </div>
    )
}